<app-loader [isLoading]="isLoading"></app-loader>

<div class="containerManageDialogue d-flex flex-column">
  <div class="topHead d-flex justify-content-between">
    <span>User Details</span>
    <div class="close-button" mat-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </div>

  </div>
  <div style="padding-bottom: 28px;">
    <div class="content-div flex-column">
      <div class="first-div d-flex flex-column">

        <div class="heading">
          <span class="grid-head">Personal Details</span>
        </div>
        <div class="info-details d-flex">
          <div class="details d-flex justify-content-between">
            <span class="details-head">Philantrophy Name</span>
            <span class="details-data">{{ 
              (!userData.phl_mem_name && !userData.phl_mem_surname) ? "-" : (
                (userData.phl_mem_name && userData.phl_mem_surname)
                  ? (userData.phl_mem_name ? userData.phl_mem_name : "")+" "+(userData.phl_mem_surname ? userData.phl_mem_surname : "")
                  : (userData.phl_mem_name ? userData.phl_mem_name : "")+(userData.phl_mem_surname ? userData.phl_mem_surname : "")
              )
            }}</span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">Email</span>
            <span class="details-data">{{
              userData.verifiedEmailId || "-"
            }}</span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">Family Code</span>
            <span class="details-data">{{
              userData.family_code || "-"
            }}</span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">State</span>
            <span class="details-data">{{
              userData.state_name || "-"
            }}</span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">District</span>
            <span class="details-data">{{
              userData.district_name || "-"
            }}</span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">PINCODE</span>
            <span class="details-data">{{
              userData.pincode || "-"
            }}</span>
          </div>
          <div class="details d-flex justify-content-between">
            <span class="details-head">Address</span>
            <span class="details-data">{{
              userData.address || "-"
            }}</span>
          </div>
          @if(isSuperUser) {
            <div class="details d-flex justify-content-between">
              <span class="details-head">Contact</span>
              <span class="details-data">{{
                  userData.contact_number2 || "-"
                }}</span>
            </div>
          }
        </div>
      </div>
      @if(isResetAllowed) {
        <div class="btn-container d-flex justify-content-end">
          <button class="dp-primary-btn btn-div" (click)="saveChanges()">
            Reset
          </button>
        </div>
      }
    </div>
  </div>
</div>